import { makeStyles, Container, Grid, Typography, Paper } from '@material-ui/core';
import { useAppStateContext } from '../../../AppStateProvider/AppStateProvider';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles({
  paper: {
    padding: '1.5em',
    borderRadius: '8px',
    width: '388px',
    '@media screen and (max-width: 950px)': {
      width: 'auto',
      marginRight: '10px',
    },
  },
  paperContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    '@media screen and (max-width: 950px)': {
      width: 'auto',
      paddingTop: '10px',
    },
  },
});

export function SupportedBrowser() {
  const { dispatch, userAgentInfo } = useAppStateContext();
  const classes = useStyles();
  const { t } = useTranslation('', { keyPrefix: 'BROWSER' });

  const browser = userAgentInfo.browser;
  const operatingSystem = userAgentInfo.os;

  return (
    <>
      <Container>
        <Grid container alignItems="center" justifyContent="space-between">
          <Grid item md={5}>
            <Typography variant="h1" gutterBottom>
              {t('BROWSER_SUPPORTED')}
            </Typography>
            <Typography variant="body1" gutterBottom>
              {t('BROWSER_PREPARED')}
            </Typography>
            <button
              type="button"
              className="n2pc-btn-primary n2pc-btn-primary_small"
              onClick={() => dispatch({ type: 'next-pane' })}
              style={{ marginRight: '1.5em', borderRadius: '6px' }}
            >
              {t('OK')}
            </button>
          </Grid>

          <Grid item md={5} className={classes.paperContainer}>
            <Paper className={classes.paper}>
              <Typography variant="body1">
                <strong>{t('BROWSER')}: </strong>
                {browser.name} {browser.version}
              </Typography>
              ​
              <Typography variant="body1">
                <strong>{t('OPERATING_SYSTEM')}: </strong>
                {operatingSystem.name} {operatingSystem.version}
              </Typography>
            </Paper>
          </Grid>
        </Grid>
      </Container>
    </>
  );
}
